import { render, staticRenderFns } from "./WikiListingItem.vue?vue&type=template&id=18098122&"
import script from "./WikiListingItem.vue?vue&type=script&lang=js&"
export * from "./WikiListingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports